import { useSearchParams } from 'react-router'
import { useIntl } from 'react-intl'

import './SortSelector.css'

export default function SortSelector() {
  const intl = useIntl()
  const [searchParams, setSearchParams] = useSearchParams()
  const sort = searchParams.get('sort') ?? 'recent'

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setSearchParams((prev) => {
      const next = new URLSearchParams(prev)
      if (e.target.value === 'recent') {
        next.delete('sort')
      } else {
        next.set('sort', e.target.value)
      }
      return next
    })
  }

  return (
    <div className="sort-selector">
      <span className="icon icon-sort" />
      <select
        title={intl.formatMessage({ id: 'sort.label' })}
        name="sort"
        aria-label={intl.formatMessage({ id: 'sort.label' })}
        value={sort}
        onChange={handleChange}
      >
        <option value="recent">
          {intl.formatMessage({ id: 'sort.recent' })}
        </option>
        <option value="oldest">
          {intl.formatMessage({ id: 'sort.oldest' })}
        </option>
        <option value="name_asc">
          {intl.formatMessage({ id: 'sort.name_asc' })}
        </option>
        <option value="name_desc">
          {intl.formatMessage({ id: 'sort.name_desc' })}
        </option>
      </select>
      <span className="icon icon-angle-down" />
    </div>
  )
}
